import { get, post } from '@/plugins/http'

export default {
  getWechatInfo: get('/user/api/v1/login/wechat/info'),
  // getUserInfoInLoginCallback: post('/user/api/v1/login/wechat/web'),
  wechatLogin: post('/live/api/v1/login/wechat'),
  // validationToken: get('/user/api/v1/token/verification'),
  loginByTicket: post('/user/api/v1/login/ticket'),
  loginByUserId: get('/live/api/v1/login/outside'),
  checkUser: post('/live/api/v1/system/check/user'),
  // getSms: post('/live/api/v1/dayone/phone/send'),
  // smsLogin: post('/live/api/v1/dayone/login'),
  loginlog: post('/live/api/v1/user/loginlog'),
  // 获取系统配置
  getSystemConfig: get('/live/api/v1/config/{keyConfig}'),
  sendMsg: post('/live/api/v1/login/phone/send?phone={phone}'),
}
